import { render, staticRenderFns } from "./PhoneNumberValidation.vue?vue&type=template&id=1545164d&"
import script from "./PhoneNumberValidation.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberValidation.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumberValidation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports